// Library imports
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "store";
import styled from "styled-components";

// Local imports
import BlankProfilePhoto from "../../../../assets/img/blank_profile_photo.png";

type Props = {
  contact_id: number;
  image?: string;
  personalityType?: String;
  userName?: String;
  disabled?: Boolean;
  // onClick?: any;
  handleAddPeople?: any;
  pColor?: string;
  email?: string;
  added?: boolean;
};
const PersonBadgeItem: React.FC<Props> = ({
  disabled,
  image,
  personalityType,
  userName,
  email,
  contact_id,
  handleAddPeople,
  pColor,
  added = false,
}) => {
  function handleOnClick() {
    if (handleAddPeople) {
      handleAddPeople(contact_id, userName, "contact", email);
    }
  }
  return (
    <Wrapper className={`${disabled ? "show-selected" : ""}`} onClick={!added ? () => handleOnClick() : undefined}>
      <div className="badge-wrapper">
        <span className="badge-img-wrapper" style={{ backgroundColor: pColor ? pColor : "#ffffff" }}>
          <img src={image ? image : BlankProfilePhoto} alt="" />
        </span>
        <span className="badge-name" style={{ backgroundColor: pColor ? pColor : "#ffffff" }}>
          {personalityType}
        </span>
      </div>
      <h6 className="user-name" data-qa="qa-sidebar-username">
        {userName !== "" ? userName : email}
      </h6>
    </Wrapper>
  );
};

export default PersonBadgeItem;

const Wrapper = styled.div`
  width: 77px;
  height: 77px;
  margin: 0px 35px 70px 15px;
  cursor: pointer;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    width: 58px;
    height: 58px;
    margin: 0px 25px 45px 10px;
  }
  &.show-selected {
    opacity: 0.5;
    pointer-events: none;
  }
  .badge-wrapper {
    height: 100%;
    width: 100%;
    position: relative;
    .badge-img-wrapper {
      height: 100%;
      width: 100%;
      background-color: #f0b520;
      border-radius: 50%;
      padding: 3px;
      display: block;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        padding: 2px;
      }
      img {
        border-radius: 50%;
        width: 100%;
        height: 100%;
        /* position: absolute;
        top: 2px;
        left: 2px; */
        /* @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          width: 53px;
          height: 53px;
        } */
      }
    }
    .badge-name {
      background-color: #f0b520;
      font-family: "robotomedium";
      letter-spacing: 1px;
      font-weight: 400;
      font-size: 10px;
      color: #fff;
      padding: 2px 7px;
      position: absolute;
      bottom: -5px;
      left: 50%;
      border-radius: 9px;
      width: auto;
      transform: translateX(-50%);
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 8px;
        border-radius: 6px;
      }
    }
  }
  .user-name {
    color: #424b50;
    font-family: "robotomedium";
    font-size: 12px;
    font-weight: 500;
    margin-bottom: 0px;
    margin-top: 20px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 77px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 8px;
      width: 58px;
    }
  }
`;
